<template>
  <div>
      	<!-- Start testomial Area -->
	<section class="testomial-area section-gap" :style="{backgroundColor:color1}">
		<div class="container">
			<div class="row d-flex justify-content-center">
				<div class="col-lg-12">
					<div class="section-title-wrap text-center">
						<h1>Our Customers Say...</h1>
						<p>See what our customers say about us before you buy anything from us. So you will get better idea about our business.</p>
					</div>
				</div>
			</div>

			<div class="row justify-content-center">
			
					<div class="single-testimonial col-md-3 col-12">
						<!-- <img class="mx-auto rounded-circle" src="../../../static/images/t1.png" alt=""> -->
                        <i class="fa fa-user-circle  mx-auto rounded-circle" style="font-size:60px;color:#ddd;"></i>
            <h4>{{review1.title}}</h4>
						<p class="desc">
						"{{review1.review}}"
						</p>						
						<p>
							{{review1.cus}}
						</p>
					</div>
					<div class="single-testimonial col-md-3 col-12">
                        <i class="fa fa-user-circle  mx-auto rounded-circle" style="font-size:60px;color:#ddd;"></i>
						<h4>{{review2.title}}</h4>
						<p class="desc">
							"{{review2.review}}"
						</p>						
						<p>
							{{review2.cus}}
						</p>
					</div>
					<div class="single-testimonial col-md-3 col-12">
                        <i class="fa fa-user-circle  mx-auto rounded-circle" style="font-size:60px;color:#ddd;"></i>
							<h4>{{review3.title}}</h4>
						<p class="desc">
							"{{review3.review}}"
						</p>					
						<p>
							{{review3.cus}}
						</p>
					</div>
				
			</div>
		</div>
	</section>
	<!-- End testomial Area -->
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
export default {
  name:'reviews',
  data () {
	 return {
  shops:[],
  color1:'',
  review1:{
    title:'',
    cus:'',
    review:''
  },
    review2:{
    title:'',
    cus:'',
    review:''
  },
    review3:{
    title:'',
    cus:'',
    review:''
  },
	
  }
 },
   created(){
		  //console.log("navigator.onLine", navigator.onLine)
	//  if(this.$store.state.shops[0] != undefined){
	// 	 this.review1 = this.$store.state.shops[0].review1
	// 	 this.review2 = this.$store.state.shops[0].review2
	// 	 this.review3 = this.$store.state.shops[0].review3
		
	// 	 console.log('footer .$store.state.shops[this.$route.params.storename] is', this.$store.state.shops[0])
	//  }else{
		 db.collection('shops').get()
      	.then(querySnapshot => {
      	querySnapshot.forEach(doc => {
		const data = {
		    'shoptype' : doc.data().shoptype,
			  'review1':doc.data().review1,
        'review2':doc.data().review2,
        'review3':doc.data().review3,
        'plan' : doc.data().plan,
        'revBackClr' :doc.data().revBackClr,   
        }
        this.shops.push(data)
		    this.review1 = this.shops[0].review1
        this.review2 = this.shops[0].review2
        this.review3 = this.shops[0].review3
        this.color1 = this.shops[0].revBackClr
		 
			console.log("footer details are", this.shops[0].details)
		  //console.log("url is", this.url)
      })
	})
	 //}
		
  }
}
</script>
<style scoped>
/*--------- Start testimonial Area -------------*/
.section-title-wrap {
  margin-bottom: 60px; }
  @media (max-width: 992px) {
    .section-title-wrap {
      margin-bottom: 40px; } }
  .section-title-wrap h1 {
    font-weight: 100;
    margin-bottom: 15px;
    color: #fff;
    line-height: 36px !important; }
    @media (max-width: 768px) {
      .section-title-wrap h1 {
        margin-bottom: 10px;
        font-size: 30px; } }
  .section-title-wrap p {
    font-weight: 400;
    max-width: 492px;
    color: #fff;
    margin: 0 auto; }
	.section-gap {
  padding: 60px 0; }
  @media (max-width: 992px) {
    .section-gap {
      padding: 50px 0; } }
  @media (max-width: 768px) {
    .section-gap {
      padding: 40px 0; } }
.testomial-area .owl-carousel .owl-item img {
  width: auto !important; }
.testomial-area .owl-dots {
  text-align: center;
  bottom: 5px;
  margin-top: 60px;
  width: 100%;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden; }
  @media (max-width: 992px) {
    .testomial-area .owl-dots {
      margin-top: 30px; } }
  @media (max-width: 768px) {
    .testomial-area .owl-dots {
      display: none !important; } }
.testomial-area .owl-dot {
  height: 10px;
  width: 10px;
  display: inline-block;
  background: rgba(127, 127, 127, 0.5);
  margin-left: 5px;
  margin-right: 5px;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s; }
.testomial-area .owl-dot.active {
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  background: #0093df; }
@media (max-width: 414px) {
  .testomial-area .active-tstimonial-carusel {
    padding: 30px; } }

.single-testimonial {
  text-align: center;
  padding: 30px;
  text-align: center;
  background: #f9f9ff;
  margin: 20px;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s; }
  .single-testimonial h4 {
    -webkit-transition: all 0.3s ease 0s;
    -moz-transition: all 0.3s ease 0s;
    -o-transition: all 0.3s ease 0s;
    transition: all 0.3s ease 0s; }
  .single-testimonial .desc {
    padding: 30px 0px; }
  .single-testimonial:hover {
    cursor: default;
    background: #23A6D5;
    box-shadow: 0px 8px 20px rgba(153, 153, 153, 0.2); }
    .single-testimonial:hover h4{
      color: #fff; }
      .single-testimonial:hover p{
      color: #fff; }
  @media (max-width: 575px) {
    .single-testimonial {
      margin: 15px; } }

/*--------- End testimonial Area -------------*/
</style>



// WEBPACK FOOTER //
// src/components/store/Reviews.vue